export function flattenModel(model) {
    let output = {};

    // Sanity checks here to help with debug
    if( model == null){
        console.log('FlattenModel getting a null ( unexpected) ', model );
    }
    if( model === undefined){
        console.log('FlattenModel getting undefined ( unexpected) ', model );
    }

    for (const [key, value] of Object.entries(model)) {

        // console.log( 'type: ', typeof value );
        // console.log( 'isArray: ', Array.isArray(value) );

        // check specifically for null, because it's an object too
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            output = {...output, ...flattenModel(value)};
        } else if (Array.isArray(value)) {
            // remove nested arrays as numerically indexed objects

            // console.log(key);

            // loop over array and check for nested objects
            if (typeof value[0] === 'object' && Array.isArray(value)) {
                let temp = value[0];
                output = { ...output, ...flattenModel(temp) };
            } else {
                let obj = flattenModel(value);
                output = {...output, ...{[key]: Object.keys(obj).map((k) => obj[k])}};
            }
            
        } else {
            output[key] = value;
        }
    }
    return output;
}